
'use client';

import { cn } from "@/lib/utils";

type TrafficLightsProps = {
  status: 'idle' | 'sequence' | 'go' | 'stopped' | 'stopping';
  lightCount?: number;
};

const Light = ({ activeColor }: { activeColor?: string }) => (
  <div className={cn(
    "w-12 h-12 md:w-16 md:h-16 rounded-full bg-neutral-800 border-2 border-neutral-600 transition-all duration-200",
    activeColor
  )} />
);

export function TrafficLights({ status, lightCount = 0 }: TrafficLightsProps) {
  const lights = Array(5).fill(null);

  return (
    <div className="flex justify-center items-center gap-3 md:gap-6 p-3 rounded-lg border-2 border-neutral-700 bg-neutral-900/50">
      {lights.map((_, index) => {
        let activeColor;
        if (status === 'sequence' && index < lightCount) {
          activeColor = "bg-red-500 shadow-[0_0_12px_3px_rgba(255,50,50,0.7)] border-red-400";
        } else if (status === 'go') {
          activeColor = "animate-green-fade";
        } else if ((status === 'stopping' && index < lightCount) || status === 'stopped') {
          activeColor = "bg-yellow-400 shadow-[0_0_12px_3px_rgba(255,255,50,0.7)] border-yellow-300";
        }
        return <Light key={index} activeColor={activeColor} />;
      })}
    </div>
  );
}
